/**
 * Module dependencies
 */
const React = require('react');
const PropTypes = require('prop-types');
const Style = require('frontend-style');
const Script = require('frontend-script');
const Head = require('react-declarative-head');
const PageContainer = require('../PageContainer');
const Platforms = require('./components/Platforms');
const Documentations = require('./components/Documentations');
const Banner = require('./components/Banner');
const BannerPartner = require('./components/BannerPartner');

const Demonstrations = require('./components/Demostrations');
const HelpComponent = require('./components/Help');
const HeaderDocs = require('./components/HeaderDocs');
const InpersonPayment = require('./components/InpersonPayment');
const OnlinePayments = require('./components/OnlinePayments');

const Home = (props) => {
  const { platform, i18n, lang, deviceType, assetsPath, brand } = props;
  const isMobile = deviceType !== 'desktop';
  const conditionSite = (platform.siteId === 'MCO') || (platform.siteId === 'MPE');

  return (
    <PageContainer
      {...props}
      hideSearch
      hideSidebar
      hideSidebarEmpty
      state={props}
      metaDescription={i18n.gettext('Integra la solución de cobro ideal para todo tipo de negocio')}
    >
      <Head />
      <title>{i18n.gettext('Documentación')}</title>
      <Style href="documentation-styles.css" />
      <Style href="app-styles.css" />
      <Script src="documentation.js" preload priority={13} />

      <div className="documentation">
        <HeaderDocs lang={lang} isMobile={isMobile} siteId={platform.siteId} i18n={i18n} assetsPath={assetsPath} brand={brand} />
        <OnlinePayments i18n={i18n} lang={lang} siteId={platform.siteId} brand={brand} />
        <Platforms i18n={i18n} siteId={platform?.siteId} lang={lang} isMobile={isMobile} brand={brand} />
        {!conditionSite && <InpersonPayment i18n={i18n} isMobile={isMobile} lang={lang} siteId={platform.siteId} brand={brand} />}
        <Documentations i18n={i18n} lang={lang} siteId={platform.siteId} brand={brand} />
        <Banner i18n={i18n} isMobile={isMobile} lang={lang} brand={brand} />
        <Demonstrations i18n={i18n} lang={lang} isMobile={isMobile} siteId={platform.siteId} brand={brand} />
        {(platform.siteId === 'MLA' || platform.siteId === 'MLM' || platform.siteId === 'MLB') && <BannerPartner i18n={i18n} isMobile={isMobile} siteId={platform.siteId} lang={lang} brand={brand} />}
        {brand !== 'yellowblue-light' && (<span className="curves-finish" />)}
        <HelpComponent i18n={i18n} lang={lang} brand={brand} />
      </div>
    </PageContainer>
  );
};

Home.propTypes = {
  platform: PropTypes.shape({
    siteId: PropTypes.string.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    gettext: PropTypes.func.isRequired,
  }).isRequired,
  lang: PropTypes.string.isRequired,
};

/**
  * Inject i18n context as props into Hom.
  */
module.exports = Home;

